// extracted by mini-css-extract-plugin
export default {"f":"_6423e34785","main":"_5afb3788b4","btn":"_2e31e76bc4","w":"d6d7d3f337","h":"_118d4420a6","lh25":"_1597df4449","wb":"_9c41234b9f","b":"_763596c623","bx":"_4f9d11d76b"};